module.exports = __webpack_public_path__ + "static/media/info-rounded-48dp.ba95fce1.svg";